// Countries Mutations

export const setFullCountriesListEn = (state, payload) => {
  state.fullCountriesListEn = payload
}

export const setFullCountriesListAr = (state, payload) => {
  state.fullCountriesListAr = payload
}
